export default {
      id: "check-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#check",
      toString: function () {
        return this.url;
      }
    }